import { useState } from 'react';

const navItems = [
  { label: '首页', href: '#home' },
  { label: '热门榜', href: '#trending' },
  { label: '分类导航', href: '#categories' },
  { label: '精选合集', href: '#collections' },
  { label: '最新更新', href: '#latest' },
  { label: '常见问题', href: '#faq' },
];

export default function SiteHeader() {
  const [open, setOpen] = useState(false);

  return (
    <header className="fixed top-0 left-0 right-0 z-50 bg-background-50/85 backdrop-blur-md border-b border-background-200">
      <div className="w-full px-4 md:px-8">
        <div className="flex items-center justify-between h-16">
          <a href="#home" className="flex items-center gap-2 cursor-pointer">
            <span className="w-9 h-9 flex items-center justify-center rounded-md bg-primary-500 text-background-50">
              <i className="ri-play-list-2-line text-lg"></i>
            </span>
            <span className="font-heading text-xl font-bold tracking-wide text-foreground-950">
              91精选
            </span>
          </a>

          <nav className="hidden md:flex items-center gap-1">
            {navItems.map((item) => (
              <a
                key={item.href}
                href={item.href}
                className="px-3 py-2 text-sm font-medium text-foreground-700 rounded-md cursor-pointer transition-colors hover:text-primary-600 hover:bg-primary-50"
              >
                {item.label}
              </a>
            ))}
          </nav>

          <div className="hidden md:flex items-center">
            <a
              href="#collections"
              className="inline-flex items-center gap-1.5 px-4 py-2 text-sm font-medium text-background-50 bg-primary-500 rounded-md cursor-pointer whitespace-nowrap transition-colors hover:bg-primary-600"
            >
              <i className="ri-compass-3-line"></i>
              开始浏览
            </a>
          </div>

          <button
            type="button"
            aria-label="打开导航菜单"
            onClick={() => setOpen((v) => !v)}
            className="md:hidden w-10 h-10 flex items-center justify-center rounded-md border border-background-200 text-foreground-800 cursor-pointer"
          >
            <i className={open ? 'ri-close-line text-xl' : 'ri-menu-line text-xl'}></i>
          </button>
        </div>
      </div>

      {open && (
        <div className="md:hidden border-t border-background-200 bg-background-50 px-4 py-3">
          <nav className="flex flex-col">
            {navItems.map((item) => (
              <a
                key={item.href}
                href={item.href}
                onClick={() => setOpen(false)}
                className="px-2 py-3 text-sm font-medium text-foreground-700 border-b border-background-100 last:border-0 cursor-pointer"
              >
                {item.label}
              </a>
            ))}
            <a
              href="#collections"
              onClick={() => setOpen(false)}
              className="mt-3 inline-flex justify-center items-center gap-1.5 px-4 py-2.5 text-sm font-medium text-background-50 bg-primary-500 rounded-md cursor-pointer"
            >
              <i className="ri-compass-3-line"></i>
              开始浏览
            </a>
          </nav>
        </div>
      )}
    </header>
  );
}